export default "/images/vendor/flag-icons/flags/1x1/ls.svg?e9b2f4ba095591e4e9c58e82f9b288f7";